import React from 'react';
import { useWizard, WizardSubStep } from '@zillow/zrs-rental-applications';
import { Flex, Heading, IconFaceUnhappy, Paragraph, TextButton } from '@zillow/constellation';
import { RENTER_CANNOT_IDV_HELP_URL } from '../../../constants/urls';
import { useIdVerificationCallbacks } from '../../../contexts/IdVerificationContext';
import { ExitReason } from '../../../../../models';

interface ForbiddenIpProps {
  id: string;
}

export default function ForbiddenIp({ id }: ForbiddenIpProps) {
  const { currentSubStep } = useWizard();
  const { onExit } = useIdVerificationCallbacks();

  return (
    <WizardSubStep
      id={id}
      hidden={currentSubStep !== id}
      meta={{
        renderNextButton: 'Done',
        renderBackButton: () => null,
      }}
      onRequestNext={(abortController: AbortController) => {
        abortController.abort();
        onExit({ reason: ExitReason.ForbiddenIp, success: false });
      }}
      render={() => (
        <Flex display="flex" flexDirection="column" gap="sm" alignItems="flex-start">
          <IconFaceUnhappy size="md" fontColor="blue600" />
          <Heading level={4} as="h2">
            We can’t complete your request
          </Heading>
          <Paragraph>
            It looks like you’re logged in from an IP address we don’t support, such as an international IP address or
            private server. You will not be able to ID verify.
          </Paragraph>
          <Paragraph>
            If you have access to a valid U.S. IP address or VPN (military or employer-provided), please connect to it
            to continue.
          </Paragraph>
          <TextButton as="a" href={RENTER_CANNOT_IDV_HELP_URL} target="_blank">
            Learn more
          </TextButton>
        </Flex>
      )}
    />
  );
}
